/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listPermissions} from '../api'

export const useMutationListPermissions = createReactQueryMutationHook('listPermissions', listPermissions)
